
export default store => next => action  => {
  console.log(action)
  return next(action)
}


/** WEBPACK FOOTER **
 ** ./middleware/logger.js
 **/


/** WEBPACK FOOTER **
 ** ./middleware/logger.js
 **/